"use client";

import { Download } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface BookCoverImageProps {
  capa?: { imagem_capa?: string; imagem_capa_png?: string } | null;
  titulo: string;
  variant?: "cover" | "thumbnail";
  size?: "sm" | "md" | "lg";
  showDownloadButton?: boolean;
  className?: string;
}

export function BookCoverImage({
  capa,
  titulo,
  variant = "cover",
  size = "md",
  showDownloadButton = false,
  className,
}: BookCoverImageProps) {
  const coverUrl = capa?.imagem_capa_png || capa?.imagem_capa;

  const handleDownload = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (coverUrl) {
      window.open(coverUrl, "_blank", "noopener,noreferrer");
    }
  };

  const sizeClasses = {
    sm: "w-16 sm:w-20",
    md: "w-28 xs:w-32 sm:w-36",
    lg: "w-40 sm:w-48 lg:w-56"
  };

  return (
    <div className={cn(
      "relative group overflow-hidden rounded-md bg-muted/30 aspect-[2/3] shadow-sm border border-border/50", 
      sizeClasses[size],
      className
    )}>
      {coverUrl ? (
        <img
          src={coverUrl}
          alt={`Capa do livro ${titulo}`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center bg-secondary/50 text-secondary-foreground text-center p-2">
          <span className="font-medium opacity-40 text-xs sm:text-sm line-clamp-3">
            {titulo}
          </span>
        </div>
      )}

      {/* Botão de Download ao passar o mouse */}
      {showDownloadButton && coverUrl && (
        <div className="absolute inset-0 bg-black/60 opacity-0 transition-opacity duration-300 group-hover:opacity-100 flex items-center justify-center backdrop-blur-sm">
          <Button 
            variant="secondary" 
            size="sm" 
            onClick={handleDownload}
            className="gap-2 shadow-lg"
          >
            <Download className="h-4 w-4" />
            <span className="hidden xs:inline">Baixar</span>
          </Button>
        </div>
      )}
    </div>
  );
}